import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerJobsInboxComponent } from './customer-jobs-inbox.component';

const routes: Routes = [
  { path: '', component: CustomerJobsInboxComponent, data: { title: 'Inbox' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerJobsInboxRoutingModule {}

@NgModule({
  imports: [
    CustomerJobsInboxRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerJobsInboxComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerJobsInboxModule {}
